// extracted by mini-css-extract-plugin
export var avatarContainer = "_ba-0";
export var avatarTypingWave = "_ba-i";
export var gray = "_ba-f";
export var green = "_ba-c";
export var icon = "_ba-9";
export var image = "_ba-1";
export var lg = "_ba-6";
export var md = "_ba-5";
export var presenceDot = "_ba-b";
export var red = "_ba-d";
export var sm = "_ba-4";
export var status = "_ba-a";
export var typingDot = "_ba-h";
export var typingPill = "_ba-g";
export var xl = "_ba-7";
export var xs = "_ba-3";
export var xxl = "_ba-8";
export var xxs = "_ba-2";
export var yellow = "_ba-e";